import axios from "axios";
import accessToken from "./jwt-token-access/accessToken";
import config from "../config/config";

//pass new generated access token here
const token = accessToken;

//apply base url for axios
const API_URL = "";

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.defaults.headers.common["Authorization"] = token;

axiosApi.interceptors.request.use(
  config => {
    let accessToken = localStorage.getItem("access_token")
    if (!accessToken) {
      const tokenVal = localStorage.getItem("Token")
      if (tokenVal) {
        try {
          accessToken = JSON.parse(tokenVal)
        } catch (e) {
          accessToken = tokenVal
        }
      }
    }
    if (accessToken) {
      config.headers = config.headers || {}
      const hasAuth = Object.keys(config.headers).some(
        key => key.toLowerCase() === "authorization"
      )
      if (!hasAuth) {
        config.headers["Authorization"] = `Bearer ${accessToken}`
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

let isLoggingOut = false;

export async function globalLogout() {
  if (isLoggingOut) return;
  isLoggingOut = true;

  let user = null;
  try {
    const userVal = localStorage.getItem("User");
    if (userVal) {
      user = JSON.parse(userVal);
    }
  } catch (e) {
    console.error("Error parsing User from localStorage", e);
  }

  const isAdmin = user === "Admin";
  const logoutUrl = isAdmin
    ? `${config.API_URL}/Admin/Admin_Logout_Api/`
    : `${config.API_URL}/Teacher/TeacherLogout_Api/`;

  const targetPath = isAdmin ? "/login" : "/teacher";
  const currentPath = window.location.pathname;

  if (currentPath === targetPath || currentPath === targetPath + "/") {
    localStorage.clear();
    isLoggingOut = false;
    return;
  }

  try {
    const token = localStorage.getItem("access_token") || (localStorage.getItem("Token") ? JSON.parse(localStorage.getItem("Token")) : null);
    if (token) {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.post(logoutUrl, {}, { headers, skipInterceptor: true });
    }
  } catch (error) {
    console.error("Error calling logout API", error);
  }

  localStorage.clear();
  isLoggingOut = false;
  window.location.href = targetPath;
}

axiosApi.interceptors.response.use(
  (response) => {
    if (response.config && response.config.skipInterceptor) {
      return response;
    }
    const token = localStorage.getItem("access_token") || localStorage.getItem("Token");
    if (token && response.data && response.data.status === 403 && response.data.msg === "Invalid token") {
      globalLogout();
    }
    return response;
  },
  (error) => {
    if (error.config && error.config.skipInterceptor) {
      return Promise.reject(error);
    }
    const token = localStorage.getItem("access_token") || localStorage.getItem("Token");
    if (
      token &&
      error.response &&
      error.response.data &&
      (error.response.data.status === 403 || error.response.status === 403) &&
      error.response.data.msg === "Invalid token"
    ) {
      globalLogout();
    }
    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
